import { gql } from '@apollo/client'
import React from 'react'

import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { integrationsClient } from '../../../../utils/apollo/api'

const Context = React.createContext([])
const { Provider } = Context
export const useIntegrationsState = () => React.useContext(Context) || {}
export const useIntegrationList = () =>
  useIntegrationsState()?.integrations?.map(integration => integration.service) || []
export const useIntegrations = () =>
  useIntegrationsState()?.integrations?.map(integration => {
    return {
      integrationService: integration.service,
      integrationId: integration.id,
      name: integration.name,
      id: integration.id
    }
  }) || []
export const useHasIntegrations = () => !!useIntegrationsState()?.integrations.length || false

const QUERY = gql`
  query Integrations($page: Int, $search: String, $sort: IntegrationSort, $filter: IntegrationFilter) {
    integrations(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      service
      insertedAt
      updatedAt
    }
  }
`

const IntegrationsLoader = ({ children, services }) => {
  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: { services },
      sort: { field: 'SERVICE' }
    },
    client: integrationsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={false}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default IntegrationsLoader
